/* global axios */
import ApiClient from './ApiClient';

class QuickActionButtonsAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  execute({ conversationId, buttonId }) {
    return axios.post(`${this.url}/${conversationId}/execute_quick_action`, {
      button_id: buttonId,
    });
  }
}

export default new QuickActionButtonsAPI();
